import s from "./CategoryFixedMobile.module.scss";
import {openTourSearch} from "../Header/tourSearch";

const CATEGORY_COLORS = [
    "#FF6B6B",
    "#4ECDC4",
    "#C7F464",
    "#FFB400",
    "#6C5CE7",
    "#45B7D1",
    "#96CEB4",
];

const CategoryFixedMobile = ({categories, onCategoryClick, activeCategory}) => {

    return (
        <div className={s.categoryList}>
            <button
                type="button"
                className={`${s.item} ${s.searchButton}`}
                onClick={openTourSearch}
                aria-label="ツアーを検索"
            >
                <i className="fa fa-search" aria-hidden="true"></i>
                <span>ツアーを検索</span>
            </button>

            {categories.slice(0, 7).map((item, i) => {
                return (

                    <div
                        key={i}
                        className={`${s.item} ${String(activeCategory) === String(item.id) ? s.active : ""}`}
                        style={{backgroundColor: CATEGORY_COLORS[i]}}
                        // style={{ flex: `0 0 ${100 / itemsPerView}%` }}
                        onClick={() => {

                            onCategoryClick(item.id)
                        }}
                    >
                        <div className={s.card}>
                            <img src={item.thumb} alt=""/>
                            <div className={s.overlayBelow}>

                                <div className={s.overlayBelowText}> {item.name}</div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )

};

export default CategoryFixedMobile;
